// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1F-MJ","inputWrap":"styles_inputWrap__2q5bN","input":"styles_input__2emmd"};